/**
 * Contexte de mesure PostHog d'une page (docs/tracking-data-attr.md) : attributs
 * `data-ph-capture-attribute-<clé>` posés par le serveur sur le conteneur racine de la fiche ou du
 * tunnel (Vehicle::trackingContext()). PostHog les ajoute à chaque clic autocapturé d'un élément
 * qu'ils englobent. Une fenêtre rendue hors de ce conteneur (fin de <body>) les recopie ici.
 * Rien n'est lu pour l'affichage ni envoyé : les attributs sont passifs.
 */
const PREFIX = "data-ph-capture-attribute-";
const ROOT_SELECTOR = `[${PREFIX}vehicle_id]`;

export function copyTrackingContext(
    target: Element,
    root: ParentNode = document,
): void {
    const source = root.querySelector(ROOT_SELECTOR);
    if (!source || source === target) return;
    for (const attr of Array.from(source.attributes)) {
        if (attr.name.startsWith(PREFIX))
            target.setAttribute(attr.name, attr.value);
    }
}
